import { useEffect, useState } from 'react';
import {
  platformApi,
  type PlatformOrganisation
} from '../../service/platform.service';

/**
 * The sandbox organisation, looked up from the unfiltered platform list once per mount.
 * It is its own fetch so a search on the Organisations page cannot hide it. Pass
 * `enabled=false` for viewers who cannot use the sandbox (no request is made), and a
 * failed lookup simply yields no sandbox, so callers render no button.
 */
export function useSandboxOrganisation(enabled = true): PlatformOrganisation | undefined {
  const [sandbox, setSandbox] = useState<PlatformOrganisation>();

  useEffect(() => {
    if (!enabled) {
      setSandbox(undefined);
      return undefined;
    }
    let cancelled = false;
    platformApi
      .organisations()
      .then((orgs) => {
        if (!cancelled) setSandbox(orgs.find((org) => org.is_sandbox));
      })
      .catch(() => {
        if (!cancelled) setSandbox(undefined);
      });
    return () => {
      cancelled = true;
    };
  }, [enabled]);

  return sandbox;
}
